export default __webpack_public_path__ + "static/media/gte.c02c2102.svg";